var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('input',_vm._g(_vm._b({staticClass:"input__node"},'input',_vm.$attrs,false),Object.assign({}, _vm.$listeners,
      {input: function (event) { return _vm.$emit('input', event.target.value); }})))])}
var staticRenderFns = []

export { render, staticRenderFns }